// import React, { useEffect, useState } from 'react';
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import Fooduserwalletorders from './Fooduserwalletorders'; // Import wallet orders component
// import './fooduserorders.css';

// const filterSelectStyle = {
//     backgroundColor: "#b15cd6",
//     color: "#fff",
//     border: "none",
//     height: "35px",
//     borderRadius: "4px",
//     padding: "0 10px",
// };

// const filterButtonStyle = {
//     backgroundColor: "#b15cd6",
//     color: "white",
//     border: "none",
//     height: "35px",
//     borderRadius: "4px",
//     padding: "0 15px",
//     cursor: "pointer",
// };

// const activeButtonStyle = {
//     backgroundColor: "#8a2be2",
//     color: "white",
//     border: "none",
//     height: "35px",
//     borderRadius: "4px",
//     padding: "0 15px",
//     cursor: "pointer",
// };

// const Fooduserorders = () => {
//     const [allOrders, setAllOrders] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [pageData, setPageData] = useState([]);
//     const [selectedDate, setSelectedDate] = useState("");
//     const [page, setPage] = useState(0);
//     const [viewType, setViewType] = useState("orders"); // "orders" or "walletOrders"
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state

//     const { showLoader, hideLoader } = useLoader();

//     // ⭐ Fetch ALL pages from backend
//     const fetchAllPages = async () => {
//         showLoader();
//         try {
//             let all = [];
//             let pageIndex = 0;

//             const token = localStorage.getItem("authToken");
//             const headers = token ? { Authorization: `Bearer ${token}` } : {};

//             while (true) {
//                 const res = await fetch(
//                     `https://backend.maamaas.com/food/api/orders/getall/${pageIndex}/10`,
//                     { method: "GET", headers }
//                 );

//                 const result = await res.json();
//                 if (!Array.isArray(result) || result.length === 0) break;

//                 all = [...all, ...result];

//                 if (result.length < 10) break;
//                 pageIndex++;
//             }

//             setAllOrders(all);
//         } catch (err) {
//             console.error("Error fetching all orders:", err);
//         } finally {
//             hideLoader();
//         }
//     };

//     useEffect(() => {
//         fetchAllPages();
//     }, []);

//     // ⭐ Apply Date Filter + Pagination + Search
//     useEffect(() => {
//         if (!allOrders.length) return;

//         let filtered = [...allOrders];

//         // Filter by date
//         if (selectedDate) {
//             const start = new Date(selectedDate);
//             start.setHours(0, 0, 0, 0);

//             const end = new Date(selectedDate);
//             end.setHours(23, 59, 59, 999);

//             filtered = filtered.filter(order => {
//                 const orderDate = new Date(order.orderDateAndTime);
//                 return orderDate >= start && orderDate <= end;
//             });
//         }

//         // Filter by search term
//         if (searchTerm.trim() !== "") {
//             const searchLower = searchTerm.toLowerCase();
//             filtered = filtered.filter(order => {
//                 return (
//                     (order.orderId && order.orderId.toString().toLowerCase().includes(searchLower)) ||
//                     (order.vendorId && order.vendorId.toString().toLowerCase().includes(searchLower)) ||
//                     (order.userName && order.userName.toLowerCase().includes(searchLower)) ||
//                     (order.paymentMethod && order.paymentMethod.toLowerCase().includes(searchLower)) ||
//                     (order.status && order.status.toLowerCase().includes(searchLower)) ||
//                     (order.userCompany && order.userCompany.toLowerCase().includes(searchLower))
//                 );
//             });
//         }

//         setFilteredData(filtered);

//         // ⭐ Slice filtered list for current page
//         const startIndex = page * 10;
//         const endIndex = startIndex + 10;
//         setPageData(filtered.slice(startIndex, endIndex));

//     }, [selectedDate, allOrders, page, searchTerm]);

//     // ⭐ Pagination controls
//     const goNext = () => {
//         if ((page + 1) * 10 < filteredData.length) {
//             setPage(page + 1);
//         }
//     };

//     const goPrevious = () => {
//         if (page > 0) setPage(page - 1);
//     };

//     const getVisiblePages = () => {
//         const totalPages = Math.ceil(filteredData.length / 10);
        
//         if (totalPages <= 3) {
//             return Array.from({ length: totalPages }, (_, i) => i);
//         }
        
//         if (page === 0) return [0, 1, 2];
//         if (page === 1) return [0, 1, 2];
//         if (page === totalPages - 1) return [page - 2, page - 1, page];
//         return [page - 1, page, page + 1];
//     };

//     // ⭐ Export CSV
//     const handleExport = () => {
//         if (filteredData.length === 0) {
//             alert("No data available for export.");
//             return;
//         }

//         const headers = [
//             "S.NO", "Order ID", "Company Name", "Date", "Time", "Category", "Type",
//             "Name", "Payment", "Status", "Amount", "Feedback", "Ratings"
//         ];

//         const csvRows = filteredData.map((item, index) => [
//             index + 1,
//             item.orderId || "",
//             item.userCompany || "-",
//             new Date(item.orderDateAndTime).toLocaleDateString(),
//             new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
//             item.appType || "Food",
//             item.orderType?.replace(/[_-]/g, "") || "-",
//             item.userName || "-",
//             item.paymentMethod?.replace(/[_-]/g, "") || "-",
//             item.status || "-",
//             Math.round(item.grandTotal) || "-",
//             item.feedback || "-",
//             item.ratings || "-"
//         ]);

//         const csvString = [headers.join(","), ...csvRows.map(r => r.join(","))].join("\r\n");

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);

//         const link = document.createElement("a");
//         link.href = url;
//         link.download = "orders.csv";
//         link.click();
//         URL.revokeObjectURL(url);
//     };

//     // ⭐ Reset page when switching views
//     const handleViewChange = (type) => {
//         setViewType(type);
//         setPage(0); // Reset to first page when switching views
//         setSelectedDate(""); // Also reset date filter
//         setSearchTerm(""); // Reset search term
//     };

//     return (
//         <div style={{ padding: "20px", marginBottom: "100px" }}>
//             {/* TAB BUTTONS CONTAINER - SAME STYLE AS USERDETAILS */}
//             <div className="sticky-top py-1 px-1" style={{ top: '50px', backgroundColor: 'white', zIndex: 101 }} >
//                 <div className="row g-2 justify-content-center justify-content-sm-evenly">
//                     {["Orders", "Wallet Orders"].map((label) => {
//                         const isActive = viewType === label.toLowerCase().replace(" ", "");
//                         return (
//                             <div className="col-auto" style={{ minWidth: '100px' }} key={label}>
//                                 <button
//                                     onClick={() => handleViewChange(label.toLowerCase().replace(" ", ""))}
//                                     style={{
//                                         border: "none",
//                                         borderRadius: "10px",
//                                         minWidth: "140px",
//                                         width: "100%",
//                                         padding: "0 10px",
//                                         height: "40px",
//                                         backgroundColor: isActive ? "#b15cd6" : "#d9d9d9",
//                                         color: isActive ? "#fff" : "#000",
//                                         fontWeight: "bold",
//                                         cursor: "pointer",
//                                         transition: "background-color 0.3s ease",
//                                         fontSize: "1rem",
//                                     }}
//                                 >
//                                     {label}
//                                 </button>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>

//             {/* Tab Content Container */}
//             <div style={{ marginTop: '60px' }}>
//                 {viewType === "orders" ? (
//                     <>
//                         {/* FILTERS */}
//                         <div className="d-flex flex-wrap align-items-center mb-3" style={{ gap: "10px" }}>
//                             <input
//                                 type="date"
//                                 value={selectedDate}
//                                 onChange={(e) => {
//                                     setSelectedDate(e.target.value);
//                                     setPage(0); // Reset to first page when date changes
//                                 }}
//                                 style={filterSelectStyle}
//                             />

//                             <input
//                                 type="text"
//                                 placeholder="Search..."
//                                 value={searchTerm}
//                                 onChange={(e) => {
//                                     setSearchTerm(e.target.value);
//                                     setPage(0); // Reset to first page when search changes
//                                 }}
//                                 style={{
//                                     backgroundColor: "#f8f9fa",
//                                     color: "#333",
//                                     border: "1px solid #ced4da",
//                                     height: "35px",
//                                     borderRadius: "4px",
//                                     padding: "0 10px",
//                                     width: "200px",
//                                 }}
//                             />

//                             <div style={{ marginLeft: "auto" }}>
//                                 <button onClick={handleExport} style={filterButtonStyle}>
//                                     Export Orders
//                                 </button>
//                             </div>
//                         </div>

//                         {/* TABLE */}
//                         <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
//                             <table className="table table-bordered table-striped align-middle">
//                                 <thead style={{ position: 'sticky', top: 0, zIndex: 100 }}>
//                                     <tr>
//                                         <th style={headerStyle}>Order ID</th>
//                                         <th style={headerStyle}>Vendor ID</th>
//                                         <th style={headerStyle}>Company Name</th>
//                                         <th style={headerStyle}>Date</th>
//                                         <th style={headerStyle}>Time</th>
//                                         <th style={headerStyle}>Category</th>
//                                         <th style={headerStyle}>Type</th>
//                                         <th style={headerStyle}>Name</th>
//                                         <th style={headerStyle}>Payment</th>
//                                         <th style={headerStyle}>Status</th>
//                                         <th style={headerStyle}>Amount</th>
//                                         <th style={headerStyle}>Feedback</th>
//                                         <th style={headerStyle}>Ratings</th>
//                                     </tr>
//                                 </thead>

//                                 <tbody>
//                                     {pageData.length > 0 ? (
//                                         pageData.map((item, index) => (
//                                             <tr key={index}>
//                                                 <td style={cellStyle}>{item.orderId}</td>
//                                                 <td style={cellStyle}>{item.vendorId}</td>
//                                                 <td style={cellStyle}>{item.userCompany || "-"}</td>
//                                                 <td style={cellStyle}>
//                                                     {(() => {
//                                                         const d = new Date(item.orderDateAndTime);
//                                                         return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
//                                                     })()}
//                                                 </td>

//                                                 <td style={cellStyle}>{new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</td>
//                                                 <td style={cellStyle}>{item.appType || "Food"}</td>
//                                                 <td style={cellStyle}>{item.orderType?.replace(/[_-]/g, "") || "-"}</td>
//                                                 <td style={cellStyle}>{item.userName || "-"}</td>
//                                                 <td style={cellStyle}>
//                                                     <span style={{
//                                                         color: item.paymentMethod?.toLowerCase().includes("wallet") ? "#28a745" : "inherit",
//                                                         fontWeight: item.paymentMethod?.toLowerCase().includes("wallet") ? "bold" : "normal"
//                                                     }}>
//                                                         {item.paymentMethod?.replace(/[_-]/g, "") || "-"}
//                                                     </span>
//                                                 </td>
//                                                 <td style={cellStyle}>{item.status || "-"}</td>
//                                                 <td style={cellStyle}>₹{Math.round(item.grandTotal) || "-"}</td>
//                                                 <td style={cellStyle}>{item.feedback || "-"}</td>
//                                                 <td style={cellStyle}>
//                                                     {[1, 2, 3, 4, 5].map(star => (
//                                                         <span key={star} style={{ color: item.ratings >= star ? "#FFD700" : "#ccc" }}>★</span>
//                                                     ))}
//                                                 </td>
//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan="13" style={{ textAlign: 'center', fontStyle: 'italic' }}>
//                                                 No orders available.
//                                             </td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>

//                         {/* PAGINATION - FIXED VERSION */}
//                         {filteredData.length > 0 && (
//                             <div className="d-flex justify-content-center mt-3" style={{ gap: "10px" }}>
//                                 <button 
//                                     disabled={page === 0} 
//                                     onClick={goPrevious} 
//                                     className="btn btn-primary"
//                                 >
//                                     Previous
//                                 </button>

//                                 {(() => {
//                                     const totalPages = Math.ceil(filteredData.length / 10);
//                                     const pagesToShow = [];
                                    
//                                     // Always show page 1
//                                     pagesToShow.push(0);
                                    
//                                     // Show current page and surrounding pages
//                                     if (page > 1) pagesToShow.push(page - 1);
//                                     if (page > 0 && page < totalPages - 1) pagesToShow.push(page);
//                                     if (page < totalPages - 2) pagesToShow.push(page + 1);
                                    
//                                     // Always show last page if there is one
//                                     if (totalPages > 1) pagesToShow.push(totalPages - 1);
                                    
//                                     // Remove duplicates and sort
//                                     const uniquePages = [...new Set(pagesToShow)].sort((a, b) => a - b);
                                    
//                                     // Render buttons
//                                     return uniquePages.map((p) => (
//                                         <button
//                                             key={p}
//                                             onClick={() => setPage(p)}
//                                             className={`btn ${page === p ? "btn-primary" : "btn-outline-primary"}`}
//                                         >
//                                             {p + 1}
//                                         </button>
//                                     ));
//                                 })()}

//                                 <button
//                                     disabled={(page + 1) * 10 >= filteredData.length}
//                                     onClick={goNext}
//                                     className="btn btn-primary"
//                                 >
//                                     Next
//                                 </button>
//                             </div>
//                         )}
//                     </>
//                 ) : (
//                     // Render Wallet Orders Component
//                     <Fooduserwalletorders />
//                 )}
//             </div>
//         </div>
//     );
// };

// const headerStyle = {
//     backgroundColor: "#b15cd6",
//     color: "#fff",
//     textAlign: "center",
//     padding: "8px",
//     border: "1px solid #ddd",
//     position: 'sticky',
//     top: 0,
//     zIndex: 100
// };

// const cellStyle = {
//     textAlign: "center",
//     padding: "8px",
//     border: "1px solid #ddd",
// };

// export default Fooduserorders;










import React, { useEffect, useState, useRef } from 'react';
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import Fooduserwalletorders from './Fooduserwalletorders';
import './fooduserorders.css';

const filterSelectStyle = {
    backgroundColor: "#b15cd6",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 10px",
};

const filterButtonStyle = {
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 15px",
    cursor: "pointer",
};

const Fooduserorders = () => {
    const [pageData, setPageData] = useState([]);
    const [totalOrders, setTotalOrders] = useState(0);
    const [selectedDate, setSelectedDate] = useState("");
    const [page, setPage] = useState(0);
    const [viewType, setViewType] = useState("orders");
    const [searchTerm, setSearchTerm] = useState("");
    
    const { showLoader, hideLoader } = useLoader();
    const pageCache = useRef(new Map()); // Cache for each page

    // ⭐ Fetch single page from backend
    const fetchPage = async (pageIndex, forceRefresh = false) => {
        // Check cache first
        const cacheKey = `${pageIndex}_${selectedDate}_${searchTerm}`;
        
        if (!forceRefresh && pageCache.current.has(cacheKey)) {
            const cachedData = pageCache.current.get(cacheKey);
            setPageData(cachedData.data);
            setTotalOrders(cachedData.total);
            return;
        }

        showLoader();
        try {
            const token = localStorage.getItem("authToken");
            const headers = token ? { Authorization: `Bearer ${token}` } : {};
            
            // Build URL with filters
            let url = `https://backend.maamaas.com/food/api/orders/getall/${pageIndex}/10`;
            
            // Add filters as query parameters
            const params = new URLSearchParams();
            if (selectedDate) {
                params.append('date', selectedDate);
            }
            if (searchTerm.trim() !== "") {
                params.append('search', searchTerm);
            }
            
            const queryString = params.toString();
            if (queryString) {
                url += `?${queryString}`;
            }

            const res = await fetch(url, { method: "GET", headers });
            const result = await res.json();
            
            if (Array.isArray(result)) {
                setPageData(result);
                
                // Get total count for pagination (you might need a separate endpoint for this)
                // For now, we'll assume if we get 10 items, there might be more
                if (result.length === 10) {
                    // This is a simplified approach - you might need a total count endpoint
                    setTotalOrders((pageIndex + 1) * 10 + 1); // Indicates there are more pages
                } else {
                    setTotalOrders(pageIndex * 10 + result.length);
                }
                
                // Cache the result
                pageCache.current.set(cacheKey, {
                    data: result,
                    total: pageIndex * 10 + result.length
                });
            }
        } catch (err) {
            console.error("Error fetching orders:", err);
        } finally {
            hideLoader();
        }
    };

    // ⭐ Fetch initial page
    useEffect(() => {
        fetchPage(0);
    }, []);

    // ⭐ Handle page change
    useEffect(() => {
        if (viewType === "orders") {
            fetchPage(page);
        }
    }, [page, viewType]);

    // ⭐ Handle filter changes
    const handleFilterChange = () => {
        setPage(0); // Reset to first page
        pageCache.current.clear(); // Clear cache when filters change
        fetchPage(0, true); // Force refresh
    };

    // ⭐ Export CSV - Limited to current filter results
    const handleExport = async () => {
        showLoader();
        try {
            const token = localStorage.getItem("authToken");
            const headers = token ? { Authorization: `Bearer ${token}` } : {};
            
            // Fetch all filtered data for export
            let allExportData = [];
            let pageIndex = 0;
            
            while (true) {
                let url = `https://backend.maamaas.com/food/api/orders/getall/${pageIndex}/50`; // Larger page size for export
                
                const params = new URLSearchParams();
                if (selectedDate) {
                    params.append('date', selectedDate);
                }
                if (searchTerm.trim() !== "") {
                    params.append('search', searchTerm);
                }
                
                const queryString = params.toString();
                if (queryString) {
                    url += `?${queryString}`;
                }
                
                const res = await fetch(url, { method: "GET", headers });
                const result = await res.json();
                
                if (!Array.isArray(result) || result.length === 0) break;
                
                allExportData = [...allExportData, ...result];
                
                if (result.length < 50) break;
                pageIndex++;
            }

            if (allExportData.length === 0) {
                alert("No data available for export.");
                return;
            }

            const headersCSV = [
                "S.NO", "Order ID", "Company Name", "Date", "Time", "Category", "Type",
                "Name", "Payment", "Status", "Amount", "Feedback", "Ratings"
            ];

            const csvRows = allExportData.map((item, index) => [
                index + 1,
                item.orderId || "",
                item.userCompany || "-",
                new Date(item.orderDateAndTime).toLocaleDateString(),
                new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                item.appType || "Food",
                item.orderType?.replace(/[_-]/g, "") || "-",
                item.userName || "-",
                item.paymentMethod?.replace(/[_-]/g, "") || "-",
                item.status || "-",
                Math.round(item.grandTotal) || "-",
                item.feedback || "-",
                item.ratings || "-"
            ]);

            const csvString = [headersCSV.join(","), ...csvRows.map(r => r.join(","))].join("\r\n");

            const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "orders.csv";
            link.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Export error:", err);
            alert("Failed to export data. Please try again.");
        } finally {
            hideLoader();
        }
    };

    // ⭐ Reset page when switching views
    const handleViewChange = (type) => {
        setViewType(type);
        setPage(0);
        setSelectedDate("");
        setSearchTerm("");
        pageCache.current.clear();
        
        if (type === "orders") {
            fetchPage(0, true);
        }
    };

    // ⭐ Pagination controls
    const goNext = () => {
        if (pageData.length === 10) { // Only go next if current page is full
            setPage(prev => prev + 1);
        }
    };

    const goPrevious = () => {
        if (page > 0) setPage(page - 1);
    };

    // ⭐ Get visible page numbers
    const getVisiblePages = () => {
        const totalPages = Math.ceil(totalOrders / 10);
        
        if (totalPages <= 3) {
            return Array.from({ length: totalPages }, (_, i) => i);
        }
        
        if (page === 0) return [0, 1, 2];
        if (page === 1) return [0, 1, 2];
        if (page === totalPages - 1) return [page - 2, page - 1, page];
        return [page - 1, page, page + 1];
    };

    return (
        <div style={{ padding: "20px", marginBottom: "100px" }}>
            {/* TAB BUTTONS CONTAINER */}
            <div className="sticky-top py-1 px-1" style={{ top: '50px', backgroundColor: 'white', zIndex: 101 }}>
                <div className="row g-2 justify-content-center justify-content-sm-evenly">
                    {["Orders", "Wallet Orders"].map((label) => {
                        const isActive = viewType === label.toLowerCase().replace(" ", "");
                        return (
                            <div className="col-auto" style={{ minWidth: '100px' }} key={label}>
                                <button
                                    onClick={() => handleViewChange(label.toLowerCase().replace(" ", ""))}
                                    style={{
                                        border: "none",
                                        borderRadius: "10px",
                                        minWidth: "140px",
                                        width: "100%",
                                        padding: "0 10px",
                                        height: "40px",
                                        backgroundColor: isActive ? "#b15cd6" : "#d9d9d9",
                                        color: isActive ? "#fff" : "#000",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        transition: "background-color 0.3s ease",
                                        fontSize: "1rem",
                                    }}
                                >
                                    {label}
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Tab Content Container */}
            <div style={{ marginTop: '60px' }}>
                {viewType === "orders" ? (
                    <>
                        {/* FILTERS */}
                        <div className="d-flex flex-wrap align-items-center mb-3" style={{ gap: "10px" }}>
                            <input
                                type="date"
                                value={selectedDate}
                                onChange={(e) => {
                                    setSelectedDate(e.target.value);
                                    setTimeout(() => handleFilterChange(), 100); // Small delay for debouncing
                                }}
                                style={filterSelectStyle}
                            />

                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setTimeout(() => handleFilterChange(), 300); // Debounce search
                                }}
                                style={{
                                    backgroundColor: "#f8f9fa",
                                    color: "#333",
                                    border: "1px solid #ced4da",
                                    height: "35px",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                    width: "200px",
                                }}
                            />

                            <div style={{ marginLeft: "auto" }}>
                                <button onClick={handleExport} style={filterButtonStyle}>
                                    Export Orders
                                </button>
                            </div>
                        </div>

                        {/* TABLE */}
                        <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
                            <table className="table table-bordered table-striped align-middle">
                                <thead style={{ position: 'sticky', top: 0, zIndex: 100 }}>
                                    <tr>
                                        <th style={headerStyle}>Order ID</th>
                                        <th style={headerStyle}>Vendor ID</th>
                                        <th style={headerStyle}>Company Name</th>
                                        <th style={headerStyle}>Date</th>
                                        <th style={headerStyle}>Time</th>
                                        <th style={headerStyle}>Category</th>
                                        <th style={headerStyle}>Type</th>
                                        <th style={headerStyle}>Name</th>
                                        <th style={headerStyle}>Payment</th>
                                        <th style={headerStyle}>Status</th>
                                        <th style={headerStyle}>Amount</th>
                                        <th style={headerStyle}>Feedback</th>
                                        <th style={headerStyle}>Ratings</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {pageData.length > 0 ? (
                                        pageData.map((item, index) => (
                                            <tr key={`${page}_${index}`}>
                                                <td style={cellStyle}>{item.orderId}</td>
                                                <td style={cellStyle}>{item.vendorId}</td>
                                                <td style={cellStyle}>{item.userCompany || "-"}</td>
                                                <td style={cellStyle}>
                                                    {(() => {
                                                        const d = new Date(item.orderDateAndTime);
                                                        return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
                                                    })()}
                                                </td>
                                                <td style={cellStyle}>{new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</td>
                                                <td style={cellStyle}>{item.appType || "Food"}</td>
                                                <td style={cellStyle}>{item.orderType?.replace(/[_-]/g, "") || "-"}</td>
                                                <td style={cellStyle}>{item.userName || "-"}</td>
                                                <td style={cellStyle}>
                                                    <span style={{
                                                        color: item.paymentMethod?.toLowerCase().includes("wallet") ? "#28a745" : "inherit",
                                                        fontWeight: item.paymentMethod?.toLowerCase().includes("wallet") ? "bold" : "normal"
                                                    }}>
                                                        {item.paymentMethod?.replace(/[_-]/g, "") || "-"}
                                                    </span>
                                                </td>
                                                <td style={cellStyle}>{item.status || "-"}</td>
                                                <td style={cellStyle}>₹{Math.round(item.grandTotal) || "-"}</td>
                                                <td style={cellStyle}>{item.feedback || "-"}</td>
                                                <td style={cellStyle}>
                                                    {[1, 2, 3, 4, 5].map(star => (
                                                        <span key={star} style={{ color: item.ratings >= star ? "#FFD700" : "#ccc" }}>★</span>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="13" style={{ textAlign: 'center', fontStyle: 'italic' }}>
                                                No orders found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* PAGINATION */}
                        {totalOrders > 0 && (
                            <div className="d-flex justify-content-center mt-3" style={{ gap: "10px" }}>
                                <button 
                                    disabled={page === 0} 
                                    onClick={goPrevious} 
                                    className="btn btn-primary"
                                >
                                    Previous
                                </button>

                                {getVisiblePages().map((p) => (
                                    <button
                                        key={p}
                                        onClick={() => setPage(p)}
                                        className={`btn ${page === p ? "btn-primary" : "btn-outline-primary"}`}
                                    >
                                        {p + 1}
                                    </button>
                                ))}

                                <button
                                    disabled={pageData.length < 10} // Disable if current page isn't full
                                    onClick={goNext}
                                    className="btn btn-primary"
                                >
                                    Next
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <Fooduserwalletorders />
                )}
            </div>
        </div>
    );
};

const headerStyle = {
    backgroundColor: "#b15cd6",
    color: "#fff",
    textAlign: "center",
    padding: "8px",
    border: "1px solid #ddd",
    position: 'sticky',
    top: 0,
    zIndex: 100
};

const cellStyle = {
    textAlign: "center",
    padding: "8px",
    border: "1px solid #ddd",
};

export default Fooduserorders;